<template>
<div class="edit_view">
        <EditHead
            ref="editHeadRef"
            :awareness="awareness"
            @gotoRoute="gotoRoute"
            @deleteFile="deleteFile"
            @updateTemplateType="updateTemplateType"
            @createCopy="createCopy"
            @moveFile="moveFile"
        />
        <div id="sensitive_content_tip" v-if="showSensitiveContentTips"></div>
        <div
            v-if="isTemplate && isMobile() === false"
            class="templateInfo"
            id="templateInfo"
        ></div>
        <KbEdit
            class="normal_view"
            @onAwarenessChange="data => (this.awareness = data)"
            @onSelectionUpdate="onSelectionUpdate"
            @onChangeEditStatus="onChangeEditStatus"
        />
         <div v-if="showSetting" id="preference_setting_dialog"></div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import Directory from '../kbdir/Directory.vue';
import EditHead from './EditHead.vue';

import KbEdit from './KbEdit.vue';

import { mapActions, mapState, mapGetters } from 'vuex';

import OtherView from '../otherview/OtherView.vue';
import { templateDetail, recognizeRisk, feedbackRisk } from '../../core/api/file';

import { getBrowser } from '../../utils/browser';

import { TocaWikiTemplateHead } from '@toca/toca-wiki-template';
import '@toca/toca-wiki-template/dist/style.css';
import { TocaWikiSensitiveTips } from '@toca/toca-wiki-template';
import '@toca/toca-wiki-template/dist/style.css';
import { debounce } from '@/utils/lodash';

export default {
  name: 'edit',
  components: {
    Directory,
    EditHead,
    OtherView,
    KbEdit },

  emits: [
  'gotoRoute',
  'deleteFile',
  'createFileWithTemplate',
  'createCopy',
  'moveFile',
  'onSelectionUpdate'],

  data() {
    return {
      cataListWidth: 45,

      recordOldValue: {
        width: '0' },

      topScrollDOM: null,
      topScrollOffset: 0,
      collaborationProvider: null,
      awareness: null, // type Array
      socketReconnectTimer: null, // NodeJS.Timeout

      _loadSuccess: false,
      contextConfig: {
        offsetLeft: 0,
        offsetTop: 0,
        contextShow: false },

      isRemoteUserEditing: false,
      currentFocusPosition: 0,
      positionDiff: 0,
      isFirstSelectionUpdate: false,
      lastScrollTop: 0,
      isTemplate: false,
      wikiTemplateHead: null,
      tocaWikiSensitiveTips: null };

  },
  watch: {
    isTemplate: {
      handler(val) {
        if (val === true) {
          this.handleTemplateInfo();
        }
      } },

    showSensitiveContentTips: {
      immediate: true,
      handler(newVal) {
        if (newVal === true) {
          let that = this;
          setTimeout(() => {
            this.tocaWikiSensitiveTips = new TocaWikiSensitiveTips('#sensitive_content_tip', {
              locale: this.wikiI18n,
              env: import.meta.env.MODE,
              onClickComplete: async (type: string) => {
                if (type === 'modify') {
                  window['tocaEditor']?.saveDocument(
                  debounce(async (result: boolean) => {
                    const res = await recognizeRisk(that.doc_id);
                    if (res.data?.code === 200) {
                      that.$message.success(intl.$t("提交成功"));
                      that.tocaWikiSensitiveTips.setSensitiveTipsStatus(1);
                    } else {
                      that.$message.error(intl.$t("提交失败，请重新提交"));
                    }
                  }, 100));

                } else if (type === 'misJudge') {
                  feedbackRisk(that.doc_id);
                }
              } });

            this.tocaWikiSensitiveTips?.setSensitiveTipsStatus(0);
          }, 500);
        }
      } } },


  created() {},
  mounted() {},

  computed: {
    ...mapState({
      doc_id: (state) => state.kbModule.doc_id,
      doc_info: (state) => state.kbEditModule.doc_info,
      edit_doc_type: (state) => state.kbEditModule.edit_doc_type,
      userId: (state) => state.userModule.userId,
      spaceId: (state) => state.userModule.spaceId,
      curHoverLinkTarget: (state) =>
      state.kbEditorLinkModule.curHoverLinkTarget,
      insertDialogVisible: (state) =>
      state.kbEditorLinkModule.insertDialogVisible,
      curHoverDialogVisible: (state) =>
      state.kbEditorLinkModule.curHoverDialogVisible,
      wikiI18n: (state: any) => state.kbModule.wikiI18n,
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo,
      showSetting: (state) => state.kbEditModule.showSetting,
      showSensitiveContentTips: (state) => state.sensitiveContentInfoModule.showSensitiveContentTips }),

    ...mapGetters({
      isCanAddFirstLevel: 'kbTreeNodeModule/isCanAddFirstLevel' }),

    isHoverLink() {
      return this.curHoverDialogVisible;
    } },

  methods: {
    ...mapActions({
      setDocInfo: 'kbEditModule/setDocInfo',
      setEditDocType: 'kbEditModule/setEditDocType' }),

    setSensitiveTipsStatus(status: number) {
      this.tocaWikiSensitiveTips?.setSensitiveTipsStatus(status);
    },
    updateLinkShareInfo(auth, scope, fileId) {
      if (this.doc_id === fileId && this.$refs.editHeadRef) {
        this.$refs.editHeadRef.updateLinkShareInfo(auth, scope, fileId);
      }
    },
    onSelectionUpdate(content: any) {
      this.$emit('onSelectionUpdate', content);
    },
    onChangeEditStatus(isCanEdit: boolean) {
      this.$emit('onChangeEditStatus', isCanEdit);
    },
    isMobile() {
      return getBrowser().isMobile;
    },
    gotoRoute(item: any) {
      this.$emit('gotoRoute', item);
    },
    deleteFile(fileId: any) {
      this.$emit('deleteFile', fileId);
    },
    updateTemplateType(templateType) {
      this.isTemplate = templateType !== null && templateType !== 0;
    },
    moveFile(data) {
      this.$emit('moveFile', data);
    },
    createCopy(data) {
      this.$emit('createCopy', data);
    },
    async handleTemplateInfo() {
      // await import('@toca/toca-wiki-template/dist/style.css');
      // const TocaWikiTemplateModule = await import(
      //     '@toca/toca-wiki-template'
      // );
      // const TocaWikiTemplateHead =
      //     TocaWikiTemplateModule.TocaWikiTemplateHead;

      const res = await templateDetail(this.doc_id);
      const { data, code } = res.data;
      if (code === 200) {
        if (data === null || data === undefined) {
          return;
        }
        const creator = data.templateCreator.userName;
        const useTimes = data.useTimes;
        const templateId = data.id;

        const params = {
          savior: {},
          templateInfo: {
            useTimes: useTimes,
            creatorName: creator,
            id: templateId },

          onUseTemplate: (templateId) => {
            this.$emit('createFileWithTemplate', templateId);
          },
          locale: this.wikiI18n };


        this.wikiTemplateHead = new TocaWikiTemplateHead(
        '#templateInfo',
        params);

      }
    },
    updateTemplateInfo(data) {
      this.wikiTemplateHead.updateTemplateInfo(data);
    },
    updateBreadcrumb() {
      if (this.$refs.editHeadRef) {
        this.$refs.editHeadRef.queryFilePath();
      }
    } },

  unmounted() {
    console.log('unmountedunmountedunmounted,', this.doc_id);
  } };
</script>

<style lang="scss" scoped>
.edit_view {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}
.normal_view {
    flex: 1;
    display: flex;
    min-width: 0;

    .edit {
        position: relative;
        overflow: hidden;
        flex: 1;
        display: flex;

        .edit_content {
            overflow: hidden;
            flex: 1;
            display: flex;
            flex-direction: column;

            .editor_content {
                display: flex;
                flex: 1;
                flex-direction: column;
                overflow: hidden;

                .edit_control_wrap {
                    user-select: none;
                    box-shadow: inset 0 -1px 0 0 #f6f6f7,
                        inset 0 1px 0 0 #f6f6f7;
                }

                .edit_wrap {
                    flex: 1;
                    display: flex;
                    overflow: hidden;
                    position: relative;

                    .edit_catalog {
                        position: absolute;
                        overflow: scroll;
                        width: 100%;
                        height: 100%;
                        transition: width 0.2s linear;
                        padding-top: 0px;
                        z-index: 10;
                        // background: yellow;
                    }

                    .edit_content_wrap {
                        // background-color: #bd438e;
                        transition: margin-left 0.2s linear;
                        overflow-anchor: auto;
                    }
                }
            }
        }
    }
}

.abnormal_view {
    flex: 1;
    display: flex;
    min-width: 0;
}
</style>

<style lang="scss">
.tiptap {
    s {
        // display: inline-flex;
    }

    ::selection {
        background-color: #5c70ff33; //影响全局了
    }
}

// .custom-ul {
//   list-style: none !important;
//   list-style-position: inside !important;
//   padding: 0px !important;

//   li {
//     list-style-type: disc !important;
//   }

//   li::marker {
//     color: #5c70ff !important;
//   }

//   p {
//     display: inline;
//   }
//   label {
//     align-items: start !important;
//     margin-top: 5px;
//   }
// }

// .custom-ol {
//   list-style: none !important;
//   list-style-position: inside !important;
//   padding: 0px !important;

//   li {
//     list-style-type: decimal !important;
//   }

//   li::marker {
//     color: #5c70ff !important;
//   }

//   p {
//     display: inline;
//   }
// }
</style>
